/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputUavMissionAnchor } from './InputUavMissionAnchor';
import {
    InputUavMissionAnchorFromJSON,
    InputUavMissionAnchorFromJSONTyped,
    InputUavMissionAnchorToJSON,
} from './InputUavMissionAnchor';
import type { InputUavMissionWaypoint } from './InputUavMissionWaypoint';
import {
    InputUavMissionWaypointFromJSON,
    InputUavMissionWaypointFromJSONTyped,
    InputUavMissionWaypointToJSON,
} from './InputUavMissionWaypoint';

/**
 * 
 * @export
 * @interface InputUavMissionFlightPath
 */
export interface InputUavMissionFlightPath {
    /**
     * 
     * @type {InputUavMissionAnchor}
     * @memberof InputUavMissionFlightPath
     */
    contactAnchor?: InputUavMissionAnchor;
    /**
     * 
     * @type {Array<InputUavMissionWaypoint>}
     * @memberof InputUavMissionFlightPath
     */
    points: Array<InputUavMissionWaypoint>;
}

/**
 * Check if a given object implements the InputUavMissionFlightPath interface.
 */
export function instanceOfInputUavMissionFlightPath(value: object): boolean {
    if (!('points' in value)) return false;
    return true;
}

export function InputUavMissionFlightPathFromJSON(json: any): InputUavMissionFlightPath {
    return InputUavMissionFlightPathFromJSONTyped(json, false);
}

export function InputUavMissionFlightPathFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionFlightPath {
    if (json == null) {
        return json;
    }
    return {
        
        'contactAnchor': json['contactAnchor'] == null ? undefined : InputUavMissionAnchorFromJSON(json['contactAnchor']),
        'points': ((json['points'] as Array<any>).map(InputUavMissionWaypointFromJSON)),
    };
}

export function InputUavMissionFlightPathToJSON(value?: InputUavMissionFlightPath | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contactAnchor': InputUavMissionAnchorToJSON(value['contactAnchor']),
        'points': ((value['points'] as Array<any>).map(InputUavMissionWaypointToJSON)),
    };
}

